<template>
  <div id="pushdown" style="background-color:white;">
    <img :src="isamnet" style="width:100%" />
    <div id="ucf-pushdown-wrapper">
      <div id="ucf-pushdown-container">
        <div id="ucf-banner-wrap">
          <a
            v-if="creative.material_type === CONSTANT.MATERIAL_TYPE.IMAGES"
            :href="creative.landing_page"
            target="_blank"
          >
            <img :src="creative.initial_image_url" id="ucf-img-banner" />
          </a>
          <div
            class="shorter"
            v-if="creative.material_type === CONSTANT.MATERIAL_TYPE.HTML"
            @click="openLandingPage"
          ></div>
          <iframe
            v-if="creative.material_type === CONSTANT.MATERIAL_TYPE.HTML"
            id="initialIframe"
            :src="creative.initial_html_url"
            scrolling="no"
            frameborder="0"
            allowfullscreen="true"
            :style="
              `border: none !important; overflow: hidden !important; display: block; background-color: black !important; width: 970px !important; height: 250px !important;`
            "
          />
          <button class="ucf-show-btn" id="ucf-show-btn" @click="showHandler">
            SHOW AD
          </button>
        </div>
        <div id="ucf-expandable-wrap">
          <a
            v-if="creative.material_type === CONSTANT.MATERIAL_TYPE.IMAGES"
            :href="creative.landing_page"
            target="_blank"
          >
            <img :src="creative.expanded_image_url" id="ucf-img-expandable" />
          </a>
          <div
            class="expandable"
            v-if="creative.material_type === CONSTANT.MATERIAL_TYPE.HTML"
            @click="openLandingPage"
          ></div>
          <iframe
            v-if="creative.material_type === CONSTANT.MATERIAL_TYPE.HTML"
            id="expandableIframe"
            :src="creative.expanded_html_url"
            scrolling="no"
            frameborder="0"
            allowfullscreen="true"
            :style="
              `border: none !important; overflow: hidden !important; display: block; background-color: black !important; width: 970px !important; height: 500px !important;`
            "
          />
          <button
            class="ucf-close-btn"
            id="ucf-close-btn"
            @click="closeHandler"
          >
            CLOSE AD
          </button>
        </div>
      </div>
    </div>
    <img
      src="https://cdn.aralego.net/rich_media/assets/pushdown/bg2.png"
      style="width:100%"
    />
  </div>
</template>

<script>
import mixPreview from "@/components/mixins/preview.js";
import mixOutstream from "@/components/mixins/outstream.js";
import mixYoutubePlayer from "@/components/mixins/youtubePlayer.js";
export default {
  data() {
    return {
      hiddenBtn: true,
      width: this.creative.initial_video_width,
      height: this.creative.initial_video_height,
      is_expand: false,
      expandIO: new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            this.showHandler();
            const wrapper = document.getElementById("ucf-pushdown-wrapper");
            this.expandIO.unobserve(wrapper);
          }
        },
        { threshold: 1 }
      ),
      player: null,
    };
  },
  computed: {
    position() {
      let layoutObj = {};

      _.forEach(["initial", "expanded"], (key) => {
        layoutObj[key] = this.setLayout(
          this.creative[`${key}_vertical_align`],
          this.creative[`${key}_vertical_padding`],
          this.creative[`${key}_horizontal_align`],
          this.creative[`${key}_horizontal_padding`]
        );
        layoutObj[key].position = "absolute";
        layoutObj[key]["z-index"] = 1000;
      });

      return layoutObj;
    },
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = "https://cdn.aralego.net/rich_media/assets";
      if (domain === "prism.amnet.tw") {
        isAmnet += "/amnet/bg2.png";
      } else {
        isAmnet += "/pushdown/bg1.png";
      }
      return isAmnet;
    },
  },
  async mounted() {
    await this.$nextTick();
    const wrapper = document.getElementById("ucf-pushdown-wrapper");
    this.setStyle(wrapper, {
      transition: "height 1s linear",
    });
    let millisecond = this.creative.millisecond;
    if (
      this.creative.material_type === CONSTANT.MATERIAL_TYPE.HTML &&
      millisecond
    ) {
      let times = this.creative.times;
      if (times > 0) {
        times = times - 1;
      }
      let timer = setInterval(() => {
        if (times !== 0) {
          if (!this.is_expand) {
            let initialIframe = document.getElementById("initialIframe");
            initialIframe.src = initialIframe.src;
          }
        } else {
          clearInterval(timer);
        }
        if (times !== -1) {
          times = times - 1;
        }
      }, millisecond);
    }

    if (this.creative.youtube_video_id) {
      let tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      let firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      const target = document.getElementById("ucf-pushdown-container");
      window.onYouTubeIframeAPIReady = () => {
        const videoId = this.creative.youtube_video_id;
        const width = this.creative.initial_video_width.toString();
        const height = this.creative.initial_video_height.toString();
        this.player = this.addYtPlayer(target, videoId, width, height);
        this.video_div.removeAttribute("style");
        this.setStyle(this.video_div, this.position.initial);
        this.expandIO.observe(wrapper);
      };
    } else if (!this.creative.vast_xml) {
      this.expandIO.observe(wrapper);
    } else {
      this.creative.vast_xml = this.removeTrackingEvent(this.creative.vast_xml);
      const target = document.getElementById("ucf-pushdown-container");
      this.addPlayer(
        target,
        this.creative.initial_video_width,
        this.creative.initial_video_height
      );
      this.video_div.removeAttribute("style");
      this.setStyle(this.video_div, this.position.initial);
    }
  },
  mixins: [mixPreview, mixOutstream, mixYoutubePlayer],
  methods: {
    showHandler() {
      this.is_expand = true;
      let millisecond = this.creative.millisecond;
      if (
        this.creative.material_type === CONSTANT.MATERIAL_TYPE.HTML &&
        millisecond
      ) {
        let expandIframe = document.getElementById("expandableIframe");
        expandIframe.src = expandIframe.src;
      }
      if (this.creative.vast_xml) {
        this.onVideoPause();
      }
      document.querySelector("#ucf-pushdown-wrapper").style.height = "500px";
      document.querySelector("#ucf-pushdown-container").style.height = "500px";
      document.querySelector("#ucf-banner-wrap").style.display = "none";
      document.querySelector("#ucf-expandable-wrap").style.display = "block";
      if (this.hiddenBtn) {
        document.querySelector(".ucf-close-btn").style.visibility = "hidden";
        setTimeout(() => {
          document.querySelector(".ucf-close-btn").style.visibility = "visible";
          this.hiddenBtn = false;
        }, 6000);
      }
      if (this.creative.youtube_video_id) {
        const width = this.creative.expanded_video_width.toString();
        const height = this.creative.expanded_video_height.toString();
        this.player.setSize(width, height);
        this.video_div.removeAttribute("style");
        this.setStyle(this.video_div, this.position.expanded);
      } else if (this.creative.vast_xml) {
        this.setPlayerSize(
          this.creative.expanded_video_width,
          this.creative.expanded_video_height
        );
        this.video_div.removeAttribute("style");
        this.setStyle(this.video_div, this.position.expanded);
        setTimeout(this.onVideoPlay, 1500);
      } else {
        let millisecond = this.creative.millisecond;
        if (
          this.creative.material_type === CONSTANT.MATERIAL_TYPE.HTML &&
          millisecond
        ) {
          setTimeout(this.closeHandler, millisecond);
        } else {
          setTimeout(this.closeHandler, 8000);
        }
      }
    },
    closeHandler() {
      this.is_expand = false;
      let millisecond = this.creative.millisecond;
      if (
        this.creative.material_type === CONSTANT.MATERIAL_TYPE.HTML &&
        millisecond
      ) {
        let initialIframe = document.getElementById("initialIframe");
        initialIframe.src = initialIframe.src;
      }
      if (this.creative.youtube_video_id) {
        this.player.pauseVideo();
      }
      if (this.creative.vast_xml) {
        this.onVideoPause();
      }
      document.querySelector("#ucf-pushdown-wrapper").style.height = "250px";
      setTimeout(() => {
        document.querySelector("#ucf-pushdown-container").style.height =
          "250px";
        document.querySelector("#ucf-banner-wrap").style.display = "block";
        document.querySelector("#ucf-expandable-wrap").style.display = "none";
      }, 1000);
      if (this.creative.youtube_video_id) {
        setTimeout(() => {
          const width = this.creative.initial_video_width.toString();
          const height = this.creative.initial_video_height.toString();
          this.player.setSize(width, height);
          this.video_div.removeAttribute("style");
          this.setStyle(this.video_div, this.position.initial);
          this.player.playVideo();
        }, 1000);
      } else if (this.creative.vast_xml) {
        setTimeout(() => {
          this.setPlayerSize(
            this.creative.initial_video_width,
            this.creative.initial_video_height
          );
          this.video_div.removeAttribute("style");
          this.setStyle(this.video_div, this.position.initial);
        }, 1000);
        setTimeout(this.onVideoPlay, 1500);
      }
    },
    messageHandler(e) {
      let frame = document.querySelector(".ucfad");
      switch (e.data.type) {
        case "close":
          frame.style.display = "none";
          break;
        case "ready":
          this.setPlayerConfig();
          this.initialAd(this.creative.vast_xml);
          this.videoIO.observe(this.video_div);
          break;
        case "Loaded":
          frame.style.display = "block";
          this.onVideoPlay();
          this.removeVideoClickDiv();
          break;
        case "Start":
          this.showToolBar();
          const video_iframe_hide = frame.contentDocument.querySelector(
            "#video_iframe_hide"
          );
          if (video_iframe_hide || this.is_expand) {
            this.closeHandler();
          } else {
            const wrapper = document.getElementById("ucf-pushdown-wrapper");
            this.expandIO.observe(wrapper);
          }
          break;
        case "error":
          this.$notify.error({
            title: "Error",
            message: e.data.error,
            position: "bottom-right",
            offset: 20,
          });
        default:
          break;
      }
    },
    openLandingPage() {
      window.open(this.creative.landing_page, "_blank");
    },
  },
};
</script>

<style lang="sass" scoped>
#ucf-pushdown-wrapper
  border: medium none
  overflow: hidden
  transform-origin: 0px 0px 0px
  transform: scale(1)
  transition: height 1s linear 0s
  height: 250px
  width: 970px
  margin: auto
  #ucf-pushdown-container
    position: relative
    cursor: pointer
    height: 100%
    width: 100%
    div
      .expandable
        height: 500px
      .shorter
        height: 250px
      width: 970px
      position: absolute
      top: 0
      left: 0
      a
        position: absolute
        z-index: 1000
        height: 100%
        width: 100%
        img
          position: absolute
          top: 0
          left: 0
          z-index: 1000
          opacity: 1
          width: 100%
          pointer-events: none
          overflow: hidden
      .ucf-show-btn,.ucf-close-btn
        background: rgba(255, 255, 255, 0.05)
        background-origin: border-box
        border-color: #474747
        border-radius: 3px
        border-style: solid
        border-width: 1px
        color: rgba(71, 71, 71, 1)
        cursor: pointer
        font-family: Arial, Arial
        font-size: 9px
        font-style: normal
        font-weight: normal
        height: 20px
        letter-spacing: normal
        line-height: 8px
        top: 3px
        opacity: 1
        outline: none
        position: absolute
        text-align: center
        text-decoration: none
        transform: rotate(0deg)
        transform-origin: 50% 50% 0px
        width: auto
        word-break: break-word
        margin: 0px
        padding: 5px
        z-index: 50000
        right: 3px

#ucf-banner-wrap, #ucf-img-banner
  height: 250px

#ucf-expandable-wrap, #ucf-img-expandable
  height: 500px

#ucf-expandable-wrap
  display: none
</style>
